/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

import { ReactComponent as ArrowForwardIcon } from '../../assets/images/arrow_forward_ios_24px.svg';

const useStyles = makeStyles((theme) => ({
    breadcrumbSection: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.detailsGrey,
    },
    parentTitle: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        lineHeight: '20px',
        color: theme.palette.text.detailsGrey,
        '@media (max-width:960px)': {
            fontSize: '17px',
        },
    },
    parentLink: {
        textDecoration: 'unset',
        color: theme.palette.text.detailsGrey,
    },
    title: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        lineHeight: '20px',
        color: theme.palette.text.label,
        '@media (max-width:960px)': {
            fontSize: '17px',
        },
    },
    arrowForward: {
        padding: '0px 14.62px',
    },
    details: {
        marginTop: '10px',
        marginBottom: '16px',
        color: theme.palette.text.detailsGrey,
        fontSize: '14px',
    },
}));

const PageTitleBreadcrumb = ({ parentTitle, parentLink, title, details }) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.breadcrumbSection}>
                <Typography className={classes.parentTitle}>
                    {parentLink ? (
                        <Link to={parentLink} className={classes.parentLink}>
                            {parentTitle}
                        </Link>
                    ) : (
                        parentTitle
                    )}
                </Typography>

                <ArrowForwardIcon className={classes.arrowForward} />
                <Typography className={classes.title}>{title}</Typography>
            </div>
            {!!details && (
                <Typography variant="body2" className={classes.details}>
                    {details}
                </Typography>
            )}
        </>
    );
};

export default PageTitleBreadcrumb;
